export class HttpParamNames {
    static readonly FROM = 'from';
    static readonly SIZE = 'size';
    static readonly FOR_SELECTION = 'forSelection';
    static readonly FOLDER_ID = 'folderId';
    static readonly ACTIVE = 'active';
}
